import { render, staticRenderFns } from "./ItemFrom.vue?vue&type=template&id=5e5f28cc&scoped=true&"
import script from "./ItemFrom.vue?vue&type=script&lang=js&"
export * from "./ItemFrom.vue?vue&type=script&lang=js&"
import style0 from "./ItemFrom.vue?vue&type=style&index=0&id=5e5f28cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f28cc",
  null
  
)

export default component.exports